import React, { useState, useEffect, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { assessmentsApi, projectsApi } from '../../../../utils'
import fromLibrary from '../../../../assests/assessments/new/from-library.png'
import noBaseProject from '../../../../assests/assessments/new/no-base-project.png'
import Card from '../../../UI/Card';
import Moment from 'moment';
import classes from "./AddProject.module.css";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ContentBankPopup from "../../ContentBank/ContentBankPopup";
import { ClassificationEnum } from "../../../../models/ClassificationContentBankEnum";
import { ObjectTypeEnum } from "../../../../models/ObjectTypeEnum";


const AddProject = forwardRef(({ setValid, assessment, handleChangeContentData, handleChangeBaseProject, isNew }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const { applicationId } = useSelector(state => state.application);

    const [fromSelected, setFromSelected] = useState({ library: false, noBaseProject: false })
    const [baseProject, setBaseProject] = useState({ id: null, name: null, createdDate: null, thumbnail: null })
    const [showLibrary, setShowLibrary] = useState(false)
    const dispatch = useDispatch();

    useEffect(() => {
        if (isNew) {
            setValid(false)
        } else {
            if (assessment.baseProjectId) {
                setFromSelected({ library: true, noBaseProject: false })
                // setBaseProjectId(assessment.baseProjectId)
                setValid(true)
                console.log("assessment.baseProject", assessment.baseProject)
                setBaseProject({
                    ...baseProject,
                    id: assessment.baseProject.id,
                    name: assessment.baseProject.name,
                    createdDate: assessment.baseProject.createdDate,
                    thumbnail: assessment.baseProject.thumbnail
                })
            } else {
                setFromSelected({ library: false, noBaseProject: true })
            }
        }
    }, [])

    const handleCardClick = (withBaseProject) => {
        if (withBaseProject) {
            setFromSelected({ library: true, noBaseProject: false })
            // handleChangeBaseProjectId(baseProjectId)
            setShowLibrary(true)
            setValid(false)
        } else {
            setFromSelected({ library: false, noBaseProject: true })
            setValid(true)
            if (assessment.baseProjectId) {
                assessmentsApi.assessmentsDeleteBaseProjectIdPost(assessment.id, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.assessmentsDeleteBaseProjectError, error: error, statusCode: response?.statusCode, message: "assessmentsDeleteBaseProjectIdPost " + error.message, level: 2, component: "AddProject", line: 45 }))
                    }
                    else {
                        console.log('resdata', resdata);
                        handleChangeContentData(resdata)
                    }
                })
            }
        }
    }

    const selectOnClick = (p) => {
        if (p.CB) {
            const projectAddInput = {
                name: p.name,
                description: p.description,
                ideId: JSON.parse(p.contentData).Ide.Id,
                refObjectType: ObjectTypeEnum.Application,
                refObjectId: applicationId
            }
            projectsApi.projectsAddPost({ projectAddInput }, (error, resdata, response) => {
                if (error) {
                    console.log('error in projectsAddPost', error)
                    dispatch(throwApiError({ userMessage: 'error in projectsAddPost', error: error, statusCode: response?.statusCode, message: "projectsAddPost " + error.message, level: 1, component: "AddProject", line: 84 }))

                } else {
                    selectOnClickCallBack(resdata);
                }
            })
        }
        else {
            selectOnClickCallBack(p);
        }
    }

    const selectOnClickCallBack = (p) => {
        const assessmentAddBaseProjectInput = {
            id: assessment.id,
            baseProjectId: p.id
        }
        assessmentsApi.assessmentsAddBaseProjectPost({ assessmentAddBaseProjectInput }, (error, resdata, response) => {
            setShowLibrary(false)
            if (error) {
                dispatch(throwApiError({ userMessage: texts.AssesmentAddBaseProjectError, error: error, statusCode: response?.statusCode, message: "assessmentsAddBaseProjectPost " + error.message, level: 2, component: "AddProject", line: 64 }))
            }
            else {
                handleChangeContentData(resdata?.contentData)
                setBaseProject({ ...baseProject, id: p.id, name: p.name, createdDate: p.createdDate, thumbnail: p.thumbnail })
                handleChangeBaseProject({ id: p.id, name: p.name, createdDate: p.createdDate, thumbnail: p.thumbnail })
                setValid(true)
            }
        })
    }

    const closeOnClick = (e) => {
        // setShowLibrary(!showLibrary)
        console.log(showLibrary)
        e.stopPropagation()
        setShowLibrary(prev => {
            return !prev
        })
        // setBaseProject({ ...baseProject, id: assessment.baseProjectId })
    }

    return (
        <div className={`${classes.AddProjectWrapper} ${classes.Overflow}`}>
            <div className={classes.AddProject}>
                <h2 className={classes.AddProjectText}>{texts.addProjectTitle}</h2>
                <div className={classes.AddBtnsWrapper}>
                    <div className={`${classes.AddFile} ${fromSelected.library && classes.WrapSelected}`} onClick={() => handleCardClick(true)}>
                        {showLibrary && <ContentBankPopup type={ClassificationEnum.project} selectOnClick={selectOnClick} closeOnClick={closeOnClick} />}
                        <Card>
                            <div className={classes.Content} style={{ backgroundImage: `url(${fromLibrary}` }}></div>
                            <div className={classes.ContentText}>{texts.fromLibrary}</div>
                        </Card>
                    </div>
                    <div className={`${classes.AddFile} ${fromSelected.noBaseProject && classes.WrapSelected}`}
                        onClick={() => handleCardClick(false)}>
                        <Card>
                            <div className={classes.Content} style={{ backgroundImage: `url(${noBaseProject}` }}></div>
                            <div className={classes.ContentText}>{texts.noNeedBaseProject}</div>
                        </Card>
                    </div>
                </div>
                {!fromSelected.noBaseProject && <div className={classes.AddProjectChosenWrapper}>
                    <div className={classes.AddProjectChosen}>{texts.chosenProject}</div>
                    <div className={classes.ShowAddProjectChosenWrapper}>
                        <div className={classes.ShowAddProjectChosenContent}>
                            <div className={classes.ProjectImgWrapper}>
                                {baseProject && baseProject.thumbnail && <div className={classes.ProjectThumbnail} style={{ backgroundImage: `url(${baseProject.thumbnail})` }}></div>}
                            </div>
                            {baseProject && baseProject.name && <div className={classes.ProjectName}>{baseProject.name}</div>}
                            {baseProject && baseProject.createdDate && <div className={classes.ProjectDate}>{Moment(baseProject.createdDate).format('DD/MM/YY')}</div>}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
})

export default AddProject;